import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/how-storage-solutions-work.jpg'),
    alt: 'drop off storage locations page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'how storage solutions work page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'How Storage <span>Services</span><span>Work with ShipAndStorage</span>',
  description:
    "Store with ease using ShipAndStorage's flexible, affordable, and secure options. With a number of facilities, storing your items is seamless and stress-free.",
  points: [
    'Six Months Free Storage',
    'Convenient Pickup & Delivery',
    'Secure, Monitored Facilities',
    'Flexible Access'
  ],
  image: {
    url: '/images/v2/pages/main-pages/how-storage-solutions-work/hero-image.jpg',
    alt: 'college storage services page'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Ship To Storage Now' }
}

export const WhyWeSectionContent = {
  title: 'How Our Storage Services Work',
  cards: [
    {
      id: 1,
      title: 'Order Your Storage Online',
      description:
        'Start by selecting your storage options on our website. Set up your storage duration and location for a hassle-free experience.',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/order-your-storage-online.svg',
        alt: 'Order Your Storage Online service'
      }
    },
    {
      id: 2,
      title: 'We Pick Up Your Items',
      description:
        'Arrange a convenient pickup time, or drop off your items at one of our storage facilities in Delaware or New York.',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/we-pick-up-your-items.svg',
        alt: 'We Pick Up Your Items service'
      }
    },
    {
      id: 3,
      title: 'Secure Storage',
      description:
        'Your items are stored in our climate-controlled, monitored warehouse for up to six months free of charge.',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/secure-storage.svg',
        alt: 'Secure Storage service'
      }
    },
    {
      id: 4,
      title: 'Ship Your Items Anytime',
      description: 'When you’re ready, simply place a new order online to retrieve or ship your items to any location.',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/ship-your-items-anytime.svg',
        alt: 'Ship Your Items Anytime service'
      }
    }
  ]
}

export const whyChooseUsSectionContent = {
  title: 'Why Choose Us for Your Storage Needs?',
  description: 'Our storage services are designed to be easy, secure, and cost-effective. ',

  articles: [
    {
      content: [
        {
          title: 'Six Months Free Storage',
          description: 'Enjoy no-cost storage for up to six months, perfect for short or seasonal storage needs.'
        },
        {
          title: 'Flexible Pickup & Delivery:',
          description: 'Schedule a door-to-door pickup or drop off your items at one of our convenient locations.'
        },
        {
          title: 'Secure Storage Facilities',
          description: 'All items are stored in monitored, climate-controlled facilities for maximum safety.'
        }
      ],
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/why-choose-us-for-your-storage-needs.jpg',
        alt: 'Why Choose Us for Your Storage Needs?'
      },
      link: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Start Storage With US' }
    }
  ]
}

export const serviceTipsSectionSectionContent = {
  title: 'What Can You Store with ShipAndStorage?',

  cards: [
    {
      id: 1,
      title: 'Seasonal Items',
      description: 'Store winter clothing, holiday decorations, and seasonal gear neatly during the off-season.',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/seasonal-items.svg',
        alt: 'Seasonal Items service'
      }
    },
    {
      id: 2,
      title: 'Student Belongings',
      description: 'Perfect for students needing short-term storage for items during summer or holiday breaks.',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/student-belongings.svg',
        alt: 'Student Belongings service'
      }
    },
    {
      id: 3,
      title: 'Sports Equipment',
      description: 'Securely store golf clubs, skis, snowboards, surfboards, and other sports equipment when not used.',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/sports-equipment.svg',
        alt: 'Sports Equipment service'
      }
    },
    {
      id: 4,
      title: 'Extra Luggage',
      description: 'Store extra bags, gifts, trade show materials, or promotional items safely and conveniently.',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/extra-luggage.svg',
        alt: 'Extra Luggage service'
      }
    },
    {
      id: 5,
      title: 'Relocation Items',
      description: 'Ideal for temporarily storing belongings while relocating to a new home or apartment.',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/relocation-items.svg',
        alt: 'Relocation Items service'
      }
    },
    {
      id: 6,
      title: 'Business Supplies',
      description: 'Store extra inventory or promotional items for easy access to meet future business needs.',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/business-supplies.svg',
        alt: 'Business Supplies service'
      }
    }
  ]
}

export const benefitsSectionSectionContent = {
  title: 'Storage Policies and Terms',

  cards: [
    {
      id: 1,
      title: 'Storage Duration',
      description: 'Enjoy up to six months of free storage; afterward, a minimal monthly fee applies.',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/storage-duration.svg',
        alt: 'Storage Duration service'
      }
    },
    {
      id: 2,
      title: 'Item Size & Weight',
      description: 'Items up to 72 inches in length and 100 lbs are accepted for safe international shipping.',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/item-Size-Weight.svg',
        alt: 'Item Size & Weight service'
      }
    },
    {
      id: 3,
      title: 'Safety Restrictions',
      description: 'Hazardous materials and flammable items are prohibited from storage.',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/safety-restrictions.svg',
        alt: 'Safety Restrictions service'
      }
    },
    {
      id: 4,
      title: 'Packaging Required',
      description: 'ShipAndStorage is not liable for items damaged due to inadequate packaging.',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/packaging-required.svg',
        alt: 'Packaging Required service'
      }
    }
  ]
}

export const forWhoSectionContent = {
  title: 'Who Can Benefit from ShipAndStorage?',
  description: 'From homeowners to businesses, we serve anyone seeking reliable storage options.',

  cards: [
    {
      id: 1,
      title: 'Homeowners',
      description:
        'Free up space at home by storing seasonal items, extra furniture, or other belongings you don’t need daily.',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/homeowners.svg',
        alt: 'Homeowners service'
      }
    },
    {
      id: 2,
      title: 'Students',
      description:
        'Store belongings over summer or winter breaks without committing to a full storage unit. We offer flexible solutions for students.',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/students.svg',
        alt: 'Students service'
      }
    },
    {
      id: 3,
      title: 'Frequent Travelers',
      description:
        'Ship and store luggage securely, giving you the freedom to travel light and access your belongings when you return.',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/frequent-travelers.svg',
        alt: 'Frequent Travelers service'
      }
    },
    {
      id: 4,
      title: 'Military Personnel',
      description:
        'Store personal items securely during deployments or relocations, with flexible access options for peace of mind.',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/military-personnel.svg',
        alt: 'Military Personnel service'
      }
    },
    {
      id: 5,
      title: 'Businesses',
      description:
        'Manage excess inventory, store important documents, or keep supplies readily accessible for events.',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/businesses.svg',
        alt: 'Businesses service'
      }
    },
    {
      id: 6,
      title: 'Event Planners',
      description:
        'Conveniently store promotional materials, display items, and event supplies in one place, ready for when they’re needed again.',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/event-planners.svg',
        alt: 'Event Planners service'
      }
    }
  ]
}

export const expertTipsSectionContent = {
  title: 'Expert Tips for a Smooth Storage Experience',

  cards: [
    {
      id: 1,
      title: 'Label Clearly',
      description: 'Use large, easy-to-read labels on all items. Clear labeling helps ensure quick processing.',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/label-clearly.svg',
        alt: 'Label Clearly service'
      }
    },
    {
      id: 2,
      title: 'Choose Sturdy Boxes',
      description: 'Durable packaging protects items during handling and storage. High-quality boxes prevent damage.',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/choose-sturdy-boxes.svg',
        alt: 'Choose Sturdy Boxes service'
      }
    },
    {
      id: 3,
      title: 'Consider Insurance',
      description: 'Consider insuring valuable or fragile items for extra coverage against unexpected damage.',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/consider-insurance.svg',
        alt: 'Consider Insurance service'
      }
    },
    {
      id: 4,
      title: 'Track Storage Duration',
      description: 'Keep track of your storage term to plan for retrieval or extended storage fees if needed. ',
      image: {
        src: '/images/v2/pages/main-pages/how-storage-solutions-work/track-storage-duration.svg',
        alt: 'Track Storage Duration service'
      }
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Ready to Simplify Your Storage?',
  description:
    'With ShipAndStorage, storing your belongings is simple, affordable, and worry-free. Whether you’re managing extra luggage, seasonal items, or preparing for a move, we’re here to provide secure, convenient storage when you need it.',
  image: {
    src: '/images/v2/pages/main-pages/how-storage-solutions-work/promotional-banner-image.svg',
    alt: 'Ready to Simplify Your Storage?'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Book Your Storage' }
}

export const faqSectionContent = {
  title: 'Frequently Asked Questions',

  questions: [
    {
      id: 1,
      question: 'What can I store with ShipAndStorage?',
      answer:
        'You can store most non-hazardous items, including seasonal items, luggage, sports equipment, and business materials. Certain size and weight restrictions apply.'
    },
    {
      id: 2,
      question: 'How do I schedule a pickup or drop-off?',
      answer: ' You can arrange a pickup or drop-off at your convenience through our online booking system.'
    },
    {
      id: 3,
      question: 'What is the maximum storage duration?',
      answer: 'We offer up to six months of free storage. For extended needs, low monthly fees are available.'
    },
    {
      id: 4,
      question: 'Can I ship my stored items to another location?',
      answer:
        'Absolutely. Simply place an online order to have items shipped to any address domestically or internationally.'
    },
    {
      id: 5,
      question: 'Is my storage facility secure?',
      answer: 'Yes, all items are stored in a climate-controlled, monitored warehouse with top security features.'
    },
    {
      id: 6,
      question: 'What if I need to access my items before my storage term is up?',
      answer: 'You can easily retrieve items anytime by creating a new order online. We’ll handle the rest.'
    }
  ]
}
